import React from "react";
import Typography from "@mui/material/Typography";
import { useAuth } from "../utils/AuthContext";
import Layout from "./Layout";
import Login from "./Login";

const Home: React.FC = () => {
  const { isLoggedIn, userName, logout } = useAuth();

  return (
    <Layout isLoggedIn={isLoggedIn} onLogout={logout} userName={userName}>
      {/* <img
        src="/BN_name_wht.jpg"
        alt="Logo"
        style={{ display: "block", margin: "32px auto 0 auto", maxWidth: "700px", width: "100%" }}
      /> */}
      {!isLoggedIn ? (
        <Login /> // No need for onLoginSuccess
      ) : (
        <Typography variant="h6" align="center">
        </Typography>
      )}
    </Layout>
  );
};

export default Home;